<template>
    <span class="embed-youtube-lazy-load relative aspect-video w-full block">
        <!-- Thumbnail with play button (shown before clicking) -->
        <span v-if="!playerLoaded" @click="loadPlayer" class="absolute inset-0 cursor-pointer block">
            <ImageOptimized
                :src="poster ?? `https://img.youtube.com/vi/${idYoutube}/mqdefault.jpg`"
                :alt="'YouTube thumbnail'"
                class="h-full w-full object-cover"
                :fetchpriority="contentful ? 'high' : 'low'"
                :loading="contentful ? 'eager' : 'lazy'"
            />
            <span class="absolute inset-0 flex items-center justify-center group">
                <button aria-label="Play Video" class="absolute z-10 rounded-lg bg-red-600 bg-opacity-80 px-8 py-3 text-white hover:bg-opacity-100">
                    <IconPlay></IconPlay>
                </button>
            </span>
        </span>

        <!-- Player container (shown after clicking) -->
        <span v-else ref="playerContainer" class="absolute inset-0 w-full h-full aspect-video"></span>
    </span>
</template>

<script>
export default {
    name: 'EmbedYoutubeLazyLoad',
    props: {
        idYoutube: {
            type: String,
            required: true
        },
        autoplay: {
            type: Boolean,
            required: false,
            default: false,
        },
        contentful: {
            type: Boolean,
            default: false,
            required: false,
        },
        poster: {
            type: String,
            required: false,
            default: null,
        }
    },
    data() {
        return {
            playerLoaded: false,
            player: null,
            thumbnailFallback: false
        };
    },
    methods: {
        async loadPlayer() {
            this.playerLoaded = true;

            const event = new Event('youtube-player-loaded');
            this.$el.dispatchEvent(event);

            // Need to wait for the DOM to update with playerContainer
            this.$nextTick(this.createPlayer);
        },
        async createPlayer() {
            const youtubeApi = await this.$youtubeApi.load();
            this.player = new youtubeApi.Player(this.$refs.playerContainer, {
                videoId: this.idYoutube,
                width: '100%',
                height: '100%',
                playerVars: {
                    autoplay: 1,
                    enablejsapi: 1
                },
            });
        }
    },
    unmounted() {
        this.player?.destroy();
    },
    mounted () {
        if(this.autoplay) this.loadPlayer();
    }
};
</script>
